import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as country from 'store/countries/actions';
import { FormBody } from 'common/components/drawer';
import selectDataFromState from 'utils/selectDataFromState';

import config from './country/config';
import Countries from './country';

const EditCountries = ({ drawer, active, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateCountry, createCountry] = useActions([country.updateCountry, country.createCountry]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active && isOpen) {
      const params = {
        ...active
      };

      const initialValues = selectDataFromState(params, config);

      loadValues({ ...initialValues });
    }

    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { ...rest } = values;

    const params = {
      ...rest,
      table: 'countries',
      id: active ? active.id : undefined
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updateCountry(params);
      } else {
        await createCountry(params);
        resetForm();
        refetchData();
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Country'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <Countries formState={formState} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditCountries;
